// extracted by mini-css-extract-plugin
export var button = "_kp-0";